import React, { useContext } from 'react';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import AnalysutdelningQuery from './Queries/AnalysutdelningQuery/AnalysutdelningQuery';
import AnalysUtdelningMain from './Components/AnalysUtdelningMain/AnalysUtdelningMain';
import ChangeUtdelningar from './Mutations/ChangeUtdelningar/ChangeUtdelningar';
import { KodplanContext } from '../../../../../Components/KodplanManager/Context/KodplanContext';
import { AvenyContext } from '../../../../AvenyContext';
import { rutinInfos } from '../../../_Common/Const/RutinInfo';
import ReadonlyPlaceholderPage from '../../../_Common/Components/RutinAvailabilityContext/ReadonylyPlaceholderPage';
import EDAvenyProgress from '../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import EDBox from '../../../../../BaseComponents/EDBox/EDBox';

interface IProps {}

const AnalysutdelningPage: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { activeDatabase, availableRoutines } = useContext(
    ActiveDatabaseContext
  );
  const {
    activeKodplan,
    loading: loadingKodplan,
    setActiveKodplan,
    availableKodplanList,
  } = useContext(KodplanContext);
  const { singleSignOnParams } = useContext(AvenyContext);

  const kodplanIdParam = singleSignOnParams.find(
    param => param.key === 'KodplanId'
  )?.value;

  // Temporärt tills rutinen anses säker för läsläge
  if (availableRoutines?.[rutinInfos.rtnAnalysutdelning.rutinID]?.readonly) {
    return <ReadonlyPlaceholderPage />;
  }

  return (
    <EDBox
      key={activeDatabase}
      sx={{ display: 'flex', overflowY: 'hidden', flex: '1 1 auto' }}
    >
      <ChangeUtdelningar>
        {changeUtdelningar => {
          if (loadingKodplan || !activeKodplan) {
            return <EDAvenyProgress />;
          } else {
            const tryChangeToKodplan = availableKodplanList.find(
              kodplan => kodplan.id === kodplanIdParam
            );
            if (
              kodplanIdParam &&
              kodplanIdParam !== activeKodplan.id &&
              tryChangeToKodplan
            ) {
              setActiveKodplan(tryChangeToKodplan);
            }

            return (
              <AnalysutdelningQuery
                activeDatabaseName={activeDatabase ? activeDatabase : ''}
                activeKodplan={activeKodplan}
              >
                {({ urval, utdelningar }) => {
                  return (
                    <AnalysUtdelningMain
                      activeCodeplanID={activeKodplan.id}
                      analyser={utdelningar}
                      urvalOptions={urval}
                      changeUtdelningar={changeUtdelningar}
                      isGasKodplan={activeKodplan.gas}
                    />
                  );
                }}
              </AnalysutdelningQuery>
            );
          }
        }}
      </ChangeUtdelningar>
    </EDBox>
  );
};

export default AnalysutdelningPage;
